import { openManageAppointmentModal as openManageAppointmentModalV2 } from '@v2/domains/appointment/components/ManageAppointmentModal/ManageAppointmentModal.component'
import { openManageAppointmentModal } from '@v2/domains/appointmentV1/components/ManageAppointmentModal/ManageAppointmentModal.component'
import { useParams } from 'react-router-dom'

import { Button } from 'src/common/components'

import withErrorBoundaryAndPolicyCheck from '../../../../../v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import styles from './schedule-appointment.module.scss'

interface IScheduleAppointment {
  className?: string
  disabled?: boolean
}

const ScheduleAppointment = (
  props: React.PropsWithChildren<IScheduleAppointment>,
) => {
  const { className, disabled } = props
  const { personId = '' } = useParams<{ personId: string }>()

  return (
    <div className={className}>
      <Button
        disabled={disabled}
        className={styles.saveButton}
        size="small"
        icon="Calendar"
        onClick={() =>
          import.meta.env.VITE_PUBLIC_NODE_ENV === 'development'
            ? openManageAppointmentModalV2(personId)
            : openManageAppointmentModal(personId)
        }
      >
        Schedule Appointment
      </Button>
    </div>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  ScheduleAppointment,
  'is_create_appointment_enabled',
)
